export default "__VITE_ASSET__BEeSsJLY__"